import { InvitationProvider, UserProvider } from ".";
import { RoleAPI, OrganizationAPI, InvitationAPI } from "../api";

const userProvider = {
  fetch: (organizationId: string) => {
    if (!organizationId) {
      return Promise.resolve([]);
    }
    return OrganizationAPI.getMembers(organizationId).then((result) => {
      return result;
    });
  },
  removeFromOrganization: (organizationId: string, userId: string) => {
    return OrganizationAPI.removeMember(organizationId, userId);
  },
  assignRole: (roleId: string, userId: string) => {
    return RoleAPI.assignRole(roleId, userId);
  },
  unassignRole: (roleId: string, userId: string) => {
    return RoleAPI.unassignRole(roleId, userId);
  },
} as UserProvider;

const invitationProvider = {
  fetch: (organizationId: string) => {
    if (!organizationId) {
      return Promise.resolve([]);
    }
    return InvitationAPI.membersByOrganization(organizationId).then(
      (result) => {
        return result;
      },
    );
  },
  delete: (id: string) => {
    return InvitationAPI.delete(id).then((result) => {
      return result;
    });
  },
  assignRole: (roleId: string, userId: string) => {
    return InvitationAPI.assignRole(roleId, userId);
  },
  unassignRole: (roleId: string, invitationId: string) => {
    return InvitationAPI.unassignRole(roleId, invitationId);
  },
} as InvitationProvider;

export { invitationProvider, userProvider };
